// Selectors
export const operatorChannelIdSelector = (state) => state.pages.browseOperatorRegions.channelId;
export const operatorIdSelector = (state) => state.pages.browseOperatorRegions.operatorId;
